<ol data-values-wrapper>
  @for (value of hours; track value) {
    <li data-time-block [attr.data-selected]="hour() === value || null">
      <button data-hour (click)="hour.set(value)">
        {{ pad(value) }}
      </button>
    </li>
  }
</ol>

<ol data-values-wrapper>
  @for (value of minutes; track value) {
    <li data-time-block [attr.data-selected]="minute() === value || null">
      <button data-minute (click)="minute.set(value)">
        {{ pad(value) }}
      </button>
    </li>
  }
</ol>

<ol data-values-wrapper>
  @for (value of periods; track value) {
    <li data-time-block [attr.data-selected]="period() === value || null">
      <button data-period (click)="period.set(value)">
        {{ value }}
      </button>
    </li>
  }
</ol>
